import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { Link as RouterLink, useNavigate } from "react-router-dom"
import Link from "@mui/material/Link";
import {
  Card,
  CardContent,
  Grid,
  List,
  ListItem,
  Paper,
  Stack,
} from "@mui/material";
import { css } from "@emotion/react";
import footerLogo from "@/assets/payment-icon.png";
import logoCrypto from "@/assets/logoCrypto.png";
import { theme } from "./theme";
import { makeStyles } from "@material-ui/core/styles";
import { pad } from "@cloudinary/url-gen/actions/resize";
import { useAuth } from "@/lib/auth";

const useStyles = makeStyles(() => ({
  footerMid: {
    flexGrow: 1,
    justifyContent: "space-between",
    display: "flex",
    flexFlow: "row nowrap",
    [theme.breakpoints.down("md")]: {
      flexFlow: "row wrap",
    },
    [theme.breakpoints.down("xs")]: {
      gap: "10px",
      "& ul": {
        width: "calc(50% - 10px)",
      },
    },
    "& .MuiList-root": {
      whiteSpace: "nowrap",
      [theme.breakpoints.down("sm")]: {
        flexFlow: "row wrap",
        paddingBlock: 0,
      },
    },
    "& .MuiListItem-root": {
      [theme.breakpoints.down("sm")]: {
        padding: " 5px 8px",
      },
    },
  },
}));
export default function Footer() {
  const auth = useAuth();
  const navigate = useNavigate();
  const classes = useStyles();
  const handleProtectedNavigation = (path: string) => {
    if (auth.user) {
      navigate(path);
    } else {
      navigate("/auth/login", {
        state: {
          from: { pathname: path },
        },
      });
    }
  };
  return (
    <Paper
      sx={{
        bottom: 0,
        backgroundColor: " #050518",
        padding: "10px 20px 40px",
      }}
      component="footer"
      square
      variant="outlined"
    >
      <Grid container spacing={{ xs: 1, sm: 1, md: 3 }}>
        <Grid item xs={12} sm={6} md={3} xl={2} order={{ xs: 0, md: 0 }}>
          <Box
            sx={{
              flexGrow: 1,
              justifyContent: "flex-start",
              display: "flex",
              my: 0,
              [theme.breakpoints.down("sm")]: {
                textAlign: "center",
              },
            }}
          >
            <Stack spacing={2} flex="1 0 1">
              <List sx={{ py: 0 }}>
                <ListItem sx={{ py: 0 }}>
                  <Link
                    underline="none"
                    href="#home"
                    sx={{
                      "@media screen and (max-width: 960px)": {
                        "& img": {
                          height: "70px !important",
                        },
                      },
                    }}
                  >
                    <img
                      src={logoCrypto}
                      style={{
                        height: "80px",
                        margin: "auto",
                      }}
                      alt="logoCrypto"
                    />
                  </Link>
                </ListItem>
                <ListItem sx={{ py: { xs: 0, md: 1 } }}>
                  <Link underline="none" href="#company">
                    <Typography
                      component="h3"
                      variant="h3"
                      sx={{ opacity: "0.6" }}
                    >
                      ADDRESS
                    </Typography>
                  </Link>
                </ListItem>
                <ListItem>
                  <Link underline="none" href="#portfolio">
                    <Typography
                      component="h3"
                      variant="h3"
                      sx={{ opacity: "0.6" }}
                    >
                      MervCF LIMITED Reg. Nr. 3-102-907134
                      <br />
                      Av. Pastor Diaz, Provincia de Puntarenas, Jaco, 61101,
                      Costa Rica
                    </Typography>
                  </Link>
                </ListItem>
              </List>
            </Stack>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={6} xl={7} order={{ xs: 2, md: 1 }}>
          <Box className={`${classes.footerMid}`}>
            <List sx={{ order: { xs: 0, sm: 0 } }}>
              <ListItem>
                <Link underline="none" href="#home">
                  <Typography
                    className="footerLinkText"
                    component="h3"
                    variant="h3"
                  >
                    POLICIES
                  </Typography>
                </Link>
              </ListItem>
              <ListItem>
                <Link underline="none" href="/termsofUse">
                  <Typography
                    component="h3"
                    variant="h3"
                    className="footerLinkText"
                    sx={{ opacity: "0.6" }}
                  >
                    Terms of Use
                  </Typography>
                </Link>
              </ListItem>
              <ListItem>
                <Link underline="none" href="/privacyNotice">
                  <Typography
                    component="h3"
                    variant="h3"
                    sx={{ opacity: "0.6" }}
                    className="footerLinkText"
                  >
                    Privacy Notice
                  </Typography>
                </Link>
              </ListItem>
              <ListItem>
                <Link underline="none" href="/KYC">
                  <Typography
                    component="h3"
                    variant="h3"
                    sx={{ opacity: "0.6" }}
                    className="footerLinkText"
                  >
                    KYC
                  </Typography>
                </Link>
              </ListItem>

              <ListItem>
                <Link underline="none" href="/responsibleGaming">
                  <Typography
                    component="h3"
                    variant="h3"
                    sx={{ opacity: "0.6" }}
                    className="footerLinkText"
                  >
                    Responsible Gaming
                  </Typography>
                </Link>
              </ListItem>
              <ListItem>
                <Link underline="none" href="/amlpolicy">
                  <Typography
                    component="h3"
                    variant="h3"
                    sx={{ opacity: "0.6" }}
                    className="footerLinkText"
                  >
                    AML Policy
                  </Typography>
                </Link>
              </ListItem>
            </List>
            <List sx={{ order: { xs: 2, sm: 1 } }}>
              <ListItem>
                <Link underline="none" href="#home">
                  <Typography
                    className="footerLinkText"
                    component="h3"
                    variant="h3"
                  >
                    ABOUT US
                  </Typography>
                </Link>
              </ListItem>
              <ListItem>
                <Link underline="none" href="/aboutus">
                  <Typography
                    component="h3"
                    variant="h3"
                    sx={{ opacity: "0.6" }}
                    className="footerLinkText"
                  >
                    About Us
                  </Typography>
                </Link>
              </ListItem>
              <ListItem>
                <Link underline="none" href="/contactUs">
                  <Typography
                    component="h3"
                    variant="h3"
                    sx={{ opacity: "0.6" }}
                    className="footerLinkText"
                  >
                    Contact Us
                  </Typography>
                </Link>
              </ListItem>
            </List>
            <List sx={{ order: { xs: 1, sm: 2 } }}>
              <ListItem>
                <Link underline="none" href="#home">
                  <Typography
                    className="footerLinkText"
                    component="h3"
                    variant="h3"
                  >
                    QUICK LINKS
                  </Typography>
                </Link>
              </ListItem>
              <ListItem>
                <Link underline="none" href="/rules">
                  <Typography
                    component="h3"
                    variant="h3"
                    sx={{ opacity: "0.6" }}
                    className="footerLinkText"
                  >
                    Rules
                  </Typography>
                </Link>
              </ListItem>
              <ListItem>
                <Link underline="none" href="/Licensing">
                  <Typography
                    component="h3"
                    variant="h3"
                    sx={{ opacity: "0.6" }}
                    className="footerLinkText"
                  >
                    Licensing
                  </Typography>
                </Link>
              </ListItem>
              <ListItem>
                <Link underline="none" href="/faq">
                  <Typography
                    component="h3"
                    variant="h3"
                    sx={{ opacity: "0.6" }}
                    className="footerLinkText"
                  >
                    FAQs
                  </Typography>
                </Link>
              </ListItem>
              <ListItem>
                <Link underline="none" href="/donations">
                  <Typography
                    component="h3"
                    variant="h3"
                    sx={{ opacity: "0.6" }}
                    className="footerLinkText"
                  >
                    Donations
                  </Typography>
                </Link>
              </ListItem>
            </List>
            <List sx={{ order: { xs: 3, sm: 3 } }}>
              <ListItem>
                <Link underline="none" href="#home">
                  <Typography
                    component="h3"
                    className="footerLinkText"
                    variant="h3"
                  >
                    PAYMENTS
                  </Typography>
                </Link>
              </ListItem>
              <ListItem>
                <Link
                  underline="none"
                  sx={{ cursor: "pointer" }}
                  onClick={() =>
                    handleProtectedNavigation("/app/wallet/MyLottery?option=deposit")
                  }
                >
                  <Typography
                    component="h3"
                    variant="h3"
                    sx={{ opacity: "0.6" }}
                    className="footerLinkText"
                  >
                    Crypto Currency
                  </Typography>
                </Link>
              </ListItem>

              <ListItem>
                <Link
                  underline="none"
                  sx={{ cursor: "pointer" }}
                  onClick={() =>
                    handleProtectedNavigation("/app/wallet/MyLottery?option=fiat")
                  }
                >
                  <Typography
                    component="h3"
                    variant="h3"
                    sx={{ opacity: "0.6" }}
                    className="footerLinkText"
                  >
                    Fiat Payments
                  </Typography>
                </Link>
              </ListItem>

              <ListItem>
                <Link
                  underline="none"
                  sx={{ cursor: "pointer" }}
                  onClick={() =>
                    handleProtectedNavigation("/app/wallet/MyLottery?option=Swap")
                  }
                >
                  <Typography
                    component="h3"
                    variant="h3"
                    sx={{ opacity: "0.6" }}
                    className="footerLinkText"
                  >
                    Buy G2F Tokens
                  </Typography>
                </Link>
              </ListItem>

              {/*  */}
            </List>
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={3}
          xl={3}
          className="footerLogoBootom"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "start",
          }}
          order={{ xs: 1, md: 2 }}
        >
          <img
            src={footerLogo}
            alt="footerLogo"
            style={{
              textAlign: "center",
              maxWidth: "100%",
              width: "auto",
              padding: "0px",
            }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
}
